module.exports = __webpack_public_path__ + "static/preview-4080fc68fd5db032eaa2ecad3337f77b.png";